import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'recra_session_id';

function getOrCreateSessionId() {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(SESSION_KEY, id);
    }
    return id;
}

export function useFollowupTracking(inputs, results) {
    const sessionId = useRef(getOrCreateSessionId());
    const debounceRef = useRef(null);
    const interactionCount = useRef(0);

    useEffect(() => {
        interactionCount.current += 1;
        // Only track after 3+ interactions to filter out passive views
        if (interactionCount.current < 3) return;

        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            fetch(`${API}/api/followup/track`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    session_id: sessionId.current,
                    calculator_data: {
                        aantalDouches: inputs.aantalDouches,
                        douchebeurtenWaarde: inputs.douchebeurtenWaarde,
                        prijsPerMinuut: inputs.prijsPerMinuut,
                        maandenOpen: inputs.maandenOpen,
                        bezettingsgraad: inputs.bezettingsgraad,
                        garantie: inputs.garantie,
                        nettoWinstMaand: results?.nettoWinstMaand,
                        nettoWinstJaar: results?.nettoWinstJaar,
                    },
                }),
            }).catch(() => {}); // silent fail. Tracking is best-effort
        }, 1500);

        return () => debounceRef.current && clearTimeout(debounceRef.current);
    }, [inputs, results]);

    const markSubmitted = () => {
        fetch(`${API}/api/followup/mark-submitted?session_id=${sessionId.current}`, {
            method: 'POST',
        }).catch(() => {});
    };

    return { sessionId: sessionId.current, markSubmitted };
}
